<template>
  <div>
    <section class="hero">
      <div class="public-wrap hero-inner">
        <img
          :src="require('@/assets/images/logos/logo.png')"
          alt="Lilo"
          class="hero-mark"
        />
        <h1>Lilo</h1>
        <p class="hero-copy"><brand-product kind="ride" />. <brand-product kind="school" />.</p>
      </div>
    </section>

    <section class="services">
      <div class="public-wrap service-grid">
        <router-link id="school" to="/register" class="service-card school">
          <div class="visual">
            <img src="@/assets/images/misc/school-bus-side-view.png" alt="" />
            <img class="badge" src="@/assets/images/misc/school.png" alt="" />
          </div>
          <div class="service-body">
            <h2><brand-product kind="school" /></h2>
            <p>{{ $t('public_school_body') }}</p>
            <div class="marks">
              <img src="@/assets/images/logos/master.png" alt="Mastercard" />
              <img src="@/assets/images/logos/stripe-account.png" alt="Stripe" />
            </div>
          </div>
        </router-link>

        <router-link id="city" to="/apps" class="service-card city">
          <div class="visual city-visual">
            <img src="@/assets/images/misc/city-taxi.svg" alt="" />
          </div>
          <div class="service-body">
            <h2><brand-product kind="ride" /></h2>
            <p>{{ $t('public_city_body') }}</p>
            <div class="marks">
              <img src="@/assets/images/logos/google.png" alt="Google Play" />
              <span>Google Play</span>
            </div>
          </div>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import BrandProduct from '@/components/BrandProduct.vue'

export default {
  components: { BrandProduct },
  mounted() {
    this.scrollHash()
  },
  watch: {
    '$route.hash'() {
      this.scrollHash()
    },
  },
  methods: {
    scrollHash() {
      const id = (this.$route.hash || '').replace('#', '')
      if (!id) return
      this.$nextTick(() => {
        const el = document.getElementById(id)
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.public-wrap {
  width: min(1160px, calc(100% - 32px));
  margin: 0 auto;
}

.hero {
  padding: 64px 0 12px;
  text-align: center;
}

.hero-mark {
  width: 88px;
  height: 88px;
  border-radius: 22px;
  object-fit: cover;
  box-shadow: 0 18px 40px rgba(31, 23, 16, 0.16);
}

.hero h1 {
  font-size: clamp(3.2rem, 8vw, 5.4rem);
  line-height: 0.95;
  margin: 18px 0 10px;
  letter-spacing: -0.04em;
}

.hero-copy {
  font-size: 1.35rem;
  color: #5a4636;
  margin: 0;
}

.services {
  padding: 36px 0 80px;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 28px;
}

.service-card {
  display: block;
  background: #fff;
  border-radius: 28px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 22px 50px rgba(31, 23, 16, 0.1);
  scroll-margin-top: 96px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.service-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 28px 60px rgba(31, 23, 16, 0.14);
}

.visual {
  position: relative;
  height: 260px;
  background: #fff1dc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.visual > img:first-child {
  width: 86%;
  max-height: 210px;
  object-fit: contain;
}

.badge {
  position: absolute;
  right: 16px;
  bottom: 14px;
  width: 72px;
  height: 72px;
  object-fit: contain;
  filter: drop-shadow(0 8px 16px rgba(31, 23, 16, 0.18));
}

.city-visual {
  background: #1a1410;
  padding: 0;
}

.city-visual img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.service-body {
  padding: 28px 28px 32px;
}

.service-card h2 {
  margin: 0 0 8px;
  font-size: 1.85rem;
  letter-spacing: -0.03em;
}

.service-card p {
  color: #5a4636;
  margin: 0 0 18px;
  line-height: 1.5;
}

.marks {
  display: flex;
  align-items: center;
  gap: 14px;
  color: #5a4636;
  font-weight: 600;
}

.marks img {
  height: 28px;
  object-fit: contain;
}

@media (max-width: 900px) {
  .service-grid {
    grid-template-columns: 1fr;
  }
}
</style>
